window.PlummeI18n.register('no', {
  "purchaseDocs.removeAll": "Fjern alle",
  "purchaseDocs.removeOne": "Fjern {name} fra kjøpet",
  "purchaseDocs.duplicateTitle": "Mulig dobbeltføring",
  "purchaseDocs.duplicateHelp": "Kontroller tidligere kjøp før du bokfører. Du kan likevel bokføre.",
  "purchaseDocs.sameAttachment": "Den samme filen er lagt ved flere ganger.",
  "purchaseDocs.sameFile": "Samme fil er brukt på bilag {number} · {date}.",
  "purchaseDocs.sameDetails": "Bilag {number} · {date} har samme dato og beløp.",
  "purchaseFlow.listTitle": "Kjøpsliste",
  "purchaseFlow.pageShown": "Denne siden: {shown} treff",
  "purchaseFlow.pageOf": "Denne siden: {shown} av {total} treff",
  "purchaseFlow.previous": "Forrige",
  "purchaseFlow.next": "Neste",
  "purchaseFlow.restart": "Oppdater fra starten",
  "purchaseFlow.retry": "Prøv igjen",
  "purchaseFlow.pageHelp": "Viser opptil 50 kjøp per side. Søk kan gi tomme sider; bruk Neste eller Forrige for å fortsette.",
  "purchaseFlow.closeBeforePaging": "Lukk detaljvisningen før du bytter side.",
  "purchaseFlow.purchaseCount": "Kjøp",
  "purchaseFlow.netPurchases": "Netto kjøp",
  "purchaseFlow.netPurchasesHelp": "Eks. MVA, etter kreditnotaer",
  "purchaseFlow.includingVat": "Inkl. MVA",
  "purchaseFlow.credited": "Kreditert",
  "purchaseFlow.creditable": "Kan fortsatt krediteres",
  "purchaseFlow.creditAllocationHelp": "Velg fakturaen før bokføring for automatisk motregning. Beløpet som overstiger ubetalt saldo blir til gode hos leverandøren.",
  "err.supplierCredit.invalidAmount": "Kreditbeløpet må være positivt og kan ikke overstige beløpet som ikke allerede er kreditert. Betalinger reduserer ikke denne grensen.",
  "err.purchase.duplicateSupplierDocument": "Dette dokumentnummeret er allerede registrert på leverandøren. Åpne den eksisterende fakturaen eller kreditnotaen.",
  'purchaseFlow.creditNote': 'Kreditnota',
  "purchaseFlow.negativeWarning": "Det er ikke vanlig med negativt beløp på en faktura med mindre det er en kreditnota.",
  "purchaseFlow.creditOriginal": "Faktura som krediteres (valgfritt)",
  "purchaseFlow.standaloneCredit": "Ingen kobling – til gode hos leverandøren",
  "purchaseFlow.creditLinesRequired": "Bruk nye, negative linjer for kreditnota. Bokfør kreditnotaen direkte; utkast og redigering støttes ikke her.",
  "err.supplierCredit.unsupportedLines": "Bruk vanlige kjøpslinjer for kreditnota. Varelager, eiendeler og spesielle MVA-behandlinger krever en egen korrigering.",
  'registry.toggleSupplierHelp': 'Foreslår norske foretak mens du skriver leverandørnavn eller organisasjonsnummer.',
  'sup.foreignToggle': 'Utenlandsk leverandør',
  'sup.foreignToggleHelp': 'Slå på for leverandører som er registrert i et annet land enn foretaket ditt.',
  'sup.countryCode': 'Landkode',
  'sup.countryCodePh': 'F.eks. SE eller US',
  'sup.countryRequired': 'Oppgi en landkode med to bokstaver for den utenlandske leverandøren.',
  'sup.registrationNumber': 'Registreringsnummer',
  'sup.registrationNumberPh': 'Leverandørens utenlandske registreringsnummer',
  'sup.vatNumber': 'VAT-/MVA-nummer',
  'sup.vatNumberPh': 'F.eks. SE123456789001',
});
